module.exports = __webpack_public_path__ + "static/media/RangePicker_Arrow.bc88f329.svg";